export function init() {
    const navTriggers = document.querySelectorAll('.mobile-trigger');

    navTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e?.preventDefault();
            document.body.classList.toggle('mobile-open');
        });
    });

    const subTriggers = document.querySelectorAll('.trigger-sub');

    subTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e?.preventDefault();
            const parent = trigger.parentNode;
            console.log(parent);
            parent.querySelector('.hs-menu-children-wrapper')?.classList?.toggle('open');
        });
    });
}